import type { FilterFieldsConfigContextProviderProps } from './FilterFieldsConfigContext.types'
import { FilterFieldsConfigContext } from './FilterFieldsConfigContext'

export const FilterFieldsConfigContextProvider = ({
  value,
  children
}: FilterFieldsConfigContextProviderProps) => {
  return (
    <FilterFieldsConfigContext.Provider value={value}>
      {children}
    </FilterFieldsConfigContext.Provider>
  )
}
